import { render, staticRenderFns } from "./AssignSidebar.vue?vue&type=template&id=e705b64e"
import script from "./AssignSidebar.vue?vue&type=script&lang=js"
export * from "./AssignSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports